import React from 'react';
import { BsFillHeartFill } from "react-icons/bs";


export default function AdsDetailSkeleton() {
    return (
        <main className="relative w-full min-h-screen py-24 md:py-40 px-4 sm:px-6 max-w-[1200px] mx-auto">
            <div className="flex flex-col md:flex-row justify-center gap-10 animate-pulse">
                {/* left: images */}
                <div className="flex flex-col md:w-1/3 order-1 md:order-2 w-full">
                    <div className="w-full h-[300px] md:h-[200px] lg:h-[300px] rounded-2xl shadow-lg overflow-hidden flex items-center justify-center bg-gradient-to-r from-gray-100 to-gray-200">
                        <div className="w-11/12 h-5/6 bg-gray-300 rounded-lg" />
                    </div>

                    <div className="flex w-full overflow-x-auto gap-3 mt-3 no-scrollbar">
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className="w-[85px] h-[85px] bg-gray-300 rounded-2xl flex-shrink-0" />
                        ))}
                    </div>
                </div>

                {/* right: details */}
                <div className="flex flex-col md:w-1/2 pe-0 md:pe-16 order-2 md:order-1 w-full">
                    <div className="flex justify-between items-start mb-2">
                        <div className="w-3/4">
                            <div className="h-8 bg-gradient-to-r from-gray-100 to-gray-200 rounded mb-2" />
                            <div className="h-5 w-1/3 bg-gray-300 rounded animate-pulse" />
                        </div>
                        {/* <div className='mt-10 w-7 h-7 pt-1 me-4 border border-gray-300 rounded-full flex items-center justify-center   '> */}
                            <BsFillHeartFill className=" text-gray-300 text-xl 
                            mt-10 me-4
                            " />
                        {/* </div> */}
                    </div>

                    <div className="bg-transparent rounded-lg p-5 my-6">
                        <h2 className="text-lg text-gray-400 font-medium mb-4">مشخصات</h2>
                        <div className="flex flex-col divide-y-[1px] divide-gray-300 gap-2 mb-4 w-full">
                            {Array.from({ length: 5 }).map((_, i) => (
                                <div key={i} className="flex flex-row justify-between pt-4 items-center w-full">
                                    <div className="h-4 w-28 bg-gray-300 rounded animate-pulse" />
                                    <div className="h-4 w-32 bg-gray-300 rounded" />
                                </div>
                            ))}
                        </div>

                        <div className="flex gap-3 items-center justify-between mt-5">
                            <div className="w-1/2 inline-flex justify-center items-center gap-2 bg-gray-300 text-white py-2 rounded-md text-sm">
                                <div className="h-4 w-4 bg-gray-300 rounded animate-pulse" />
                                <div className="h-4 w-20 bg-gray-300 rounded animate-pulse" />
                            </div>
                            <div className="text-md text-gray-800 font-bold bg-gray-300 rounded px-4 py-2 animate-pulse">&nbsp;</div>
                        </div>

                        <div className="flex-col justify-start items-center w-full mt-8">
                            <h2 className="text-lg text-gray-400 font-medium mb-4">توضیحات</h2>
                            <div className="space-y-2">
                                <div className="h-3 bg-gray-300 rounded w-full animate-pulse" />
                                <div className="h-3 bg-gray-300 rounded w-full animate-pulse" />
                                <div className="h-3 bg-gray-300 rounded w-3/4 animate-pulse" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
